import { getServerSideSitemap } from 'next-sitemap';
import { GetServerSidePropsContext } from 'next';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {};

export async function getServerSideProps(_context: GetServerSidePropsContext) {
  const fields = [
    {
      loc: process.env.SITE_URL as string,
      lastmod: new Date().toISOString(),
    },
    {
      loc: `${process.env.SITE_URL}results`,
      lastmod: new Date().toISOString(),
    },
  ];

  return getServerSideSitemap(fields);
}
